import { types } from "mobx-state-tree"

const MikaSplitTime = types.model('MikaSplitTime', {
    id: types.identifierNumber,
    key: types.string,
    name: types.string,
})

export default MikaSplitTime
